export class VersionService {
    $http;
    $mdDialog;
    $translate;
    $window;
    config;
    log;
    version;
    dialogShowing = false;
    static $inject = ['$http', '$mdDialog', '$translate', '$window', 'CONFIG', 'LogService'];
    constructor($http, $mdDialog, $translate, $window, CONFIG, logService) {
        this.$http = $http;
        this.$mdDialog = $mdDialog;
        this.$translate = $translate;
        this.$window = $window;
        this.config = CONFIG;
        this.log = logService.getLogger('Version-S');
    }
    initVersion() {
        if (this.version !== undefined) {
            this.checkForUpdate();
            return;
        }
        this.fetchVersion()
            .then((version) => {
            this.version = version;
            this.log.info('Using Threema Web version', this.version);
        })
            .catch((error) => {
            this.log.error('Could not fetch version.txt:', error);
        });
    }
    fetchVersion() {
        return new Promise((resolve, reject) => {
            const cacheBust = Math.floor(Math.random() * 1000000000);
            this.$http({
                method: 'GET',
                url: 'version.txt?' + cacheBust,
                cache: false,
                responseType: 'text',
                transformResponse: (data, headersGetter, statusCode) => {
                    if (statusCode !== 200) {
                        return reject('HTTP ' + statusCode);
                    }
                    return data.trim();
                },
            }).then((successResponse) => {
                return resolve(successResponse.data);
            }, (error) => {
                return reject(error);
            });
        });
    }
    checkForUpdate() {
        this.log.debug('Checking for version update...');
        if (this.version === undefined) {
            this.log.error('Cannot check for update, version is not initialized');
            return;
        }
        this.fetchVersion()
            .then((version) => {
            if (version !== this.version) {
                this.log.warn('A new version of Threema Web is available:', this.version, '->', version);
                this.notifyNewVersion(version);
            }
        })
            .catch((error) => {
            this.log.error('Could not fetch version.txt:', error);
        });
    }
    notifyNewVersion(version) {
        if (this.dialogShowing === true) {
            return;
        }
        const changelogUrl = 'https://github.com/threema-ch/threema-web/blob/'
            + this.config.GIT_BRANCH
            + '/CHANGELOG.md';
        const changelogLink = '<a href="' + changelogUrl + '" target="_blank" rel="noopener noreferrer">Changelog</a>';
        const confirm = this.$mdDialog.alert()
            .title(this.$translate.instant('version.NEW_VERSION'))
            .htmlContent(this.$translate.instant('version.NEW_VERSION_BODY', {
            version: version,
            changelog: changelogLink,
        }))
            .ok(this.$translate.instant('common.OK'));
        this.dialogShowing = true;
        this.$mdDialog.show(confirm).then(() => {
            this.$window.location.reload();
        }, () => {
            this.$window.location.reload();
        });
    }
}
